<template>
  <van-cell-group inset>
    <div class="date-fields">
      <van-field
        v-model="innerStartTime"
        readonly
        placeholder="请选择"
        inputmode="none"
        @click="openDatePicker('startTime')"
      />
      <span class="separator">至</span>
      <van-field
        v-model="innerEndTime"
        readonly
        placeholder="请选择"
        inputmode="none"
        @click="openDatePicker('endTime')"
      />
    </div>
    <div class="quick-date">
      <van-button
        v-for="btn in dateButtons"
        :key="btn.type"
        size="mini"
        :type="quickDateType === btn.type ? 'primary' : 'default'"
        @click="setQuickDate(btn.type)"
        >{{ btn.label }}</van-button
      >
    </div>
    <DateTimePicker
      :showPicker="showDatePicker"
      :values="pickerValues"
      @confirm="onDateConfirm"
      @cancel="showDatePicker = false"
    />
  </van-cell-group>
</template>
<script>
import DateTimePicker from "@/components/dateTimePicker";

export default {
  name: "QuickDatePicker",
  components: { DateTimePicker },
  props: {
    startTime: { type: String, default: "" },
    endTime: { type: String, default: "" },
    // 默认选中的快捷类型，不传则不选
    defaultType: { type: String, default: "" },
  },
  data() {
    return {
      innerStartTime: this.startTime || "",
      innerEndTime: this.endTime || "",
      // 当前选中的快捷类型
      quickDateType: "",
      showDatePicker: false,
      dateKey: "",
      pickerValues: "",
      dateButtons: [
        { type: "prevDay", label: "上一天" },
        { type: "today", label: "今天" },
        { type: "nextDay", label: "下一天" },
        { type: "prevMonth", label: "上月" },
        { type: "thisMonth", label: "本月" },
      ],
    };
  },
  mounted() {
    // 默认选中由父组件传入的 defaultType 决定
    if (this.defaultType) {
      this.setQuickDate(this.defaultType);
    }
  },
  watch: {
    startTime(val) {
      this.innerStartTime = val;
      if (!val && !this.innerEndTime) this.quickDateType = "";
    },
    endTime(val) {
      this.innerEndTime = val;
      if (!val && !this.innerStartTime) this.quickDateType = "";
    },
  },
  methods: {
    // 通知父组件日期变更
    emitChange() {
      this.$emit("update:startTime", this.innerStartTime);
      this.$emit("update:endTime", this.innerEndTime);
      this.$emit("change", {
        startTime: this.innerStartTime,
        endTime: this.innerEndTime,
      });
    },
    formatDate(d) {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
       return `${y}-${m}-${day}`
    },
    // 解析当前选中日期作为基准（无则用今天）
    getBaseDate() {
      if (this.innerStartTime) {
        return new Date(this.innerStartTime.replace(/-/g, "/"));
      }
      return new Date();
    },
    // 快捷日期选择（支持连续点击：每次基于当前选中日期递增/递减）
    setQuickDate(type) {
      this.quickDateType = type;
      const base = this.getBaseDate();
      switch (type) {
        case "prevDay": {
          // 在当前基础上减一天
          base.setDate(base.getDate() - 1);
          this.innerStartTime = this.formatDate(base);
          this.innerEndTime = this.formatDate(base);
          break;
        }
        case "today": {
          const now = new Date();
          this.innerStartTime = this.formatDate(now);
          this.innerEndTime = this.formatDate(now);
          break;
        }
        case "nextDay": {
          // 在当前基础上加一天
          base.setDate(base.getDate() + 1);
          this.innerStartTime = this.formatDate(base);
          this.innerEndTime = this.formatDate(base);
          break;
        }
        case "prevMonth": {
          // 在当前月份基础上往前一个月
          const start = new Date(base.getFullYear(), base.getMonth() - 1, 1);
          const end = new Date(base.getFullYear(), base.getMonth(), 0);
          this.innerStartTime = this.formatDate(start);
          this.innerEndTime = this.formatDate(end);
          break;
        }
        case "thisMonth": {
          const now = new Date();
          const start = new Date(now.getFullYear(), now.getMonth(), 1);
          this.innerStartTime = this.formatDate(start);
          this.innerEndTime = this.formatDate(now);
          break;
        }
        default:
          return;
      }
      this.emitChange();
    },
    openDatePicker(key) {
      this.dateKey = key;
      this.pickerValues =
        key === "startTime" ? this.innerStartTime : this.innerEndTime;
      this.showDatePicker = true;
    },
    onDateConfirm(value) {
      // 手动选择日期只保留日期部分（YYYY-MM-DD），时分秒由父组件拼接
      const dateStr = value ? value.split(" ")[0] : "";
      if (this.dateKey === "startTime") {
        this.innerStartTime = dateStr;
      } else {
        this.innerEndTime = dateStr;
      }
      // 手动选择日期时清除快捷选中状态
      this.quickDateType = "";
      this.showDatePicker = false;
      this.emitChange();
    },
  },
};
</script>
<style lang="less" scoped>
.date-fields {
  display: flex;
  align-items: center;

  .separator {
    margin: 0 4px;
    color: #999;
    flex-shrink: 0;
  }
}

.quick-date {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px 0;
}
</style>
